import React, { useRef, useEffect, useContext } from 'react';

import { Modal as BootstrapModal } from 'bootstrap';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import { useModal } from '../context/ModalContext';
import { UserContext } from '../context/UserContext';

import Chat from './Chat';
import { fireEvent } from '../utils/marketing';
import ModalSlider from './modalTemplates/ModalSlider';
import ModalCard from './modalTemplates/ModalCard';
import ModalList from './modalTemplates/ModalList';
import ModalSliderKitDetails from './modalTemplates/ModalSliderKitDetails';
import ModalSliderKitFormula from './modalTemplates/ModalSliderKitFormula';
import ModalSliderCustom from './modalTemplates/ModalSliderCustom';
import ModalKitContentFarma from './modalTemplates/ModalKitContentFarma';
import ModalCardPesquisa from './modalTemplates/ModalPesquisa';
import ModalInfo from './modalTemplates/ModalInfo';
import ModalCardBase from './modalTemplates/ModalCardBase';
import ModalVideo from './modalTemplates/ModalVideo';
import ModalLogin from './modalTemplates/ModalLogin';
import ModalSalesSuspended from './modalTemplates/ModalSalesSuspended';
import { SALES_SUSPENDED } from '../config/salesSuspended';
import ModalFamilyProfile from './modalTemplates/ModalFamilyProfile';
import ModalTracking from './modalTemplates/ModalTracking';
import ModalImage from './modalTemplates/ModalImage';
import ModalConfirmation from './modalTemplates/ModalConfirmation';
import ModalAnamnesisRenew from './modalTemplates/ModalAnamnesisRenew';
import ModalAnamneseUpgradeV2 from './modalTemplates/ModalAnamneseUpgradeV2';
import ModalModalidades from './modalTemplates/ModalModalidades';
import ModalTerms from './modalTemplates/ModalTerms';
import ModalIframe from './modalTemplates/ModalIframe';
import ModalRetiradaLoja from "./modalTemplates/ModalRetiradaLoja";
import ModalPendingPayment from "./modalTemplates/ModalPendingPayment";
import FormLead from './FormLead';
import '../assets/styles/modal-image.css';

const Modal = () => {
  const { isModalOpen, closeModal, modalType, modalData, openModal, openCount, isModalLocked } = useModal();
  const { isAuthenticated } = useContext(UserContext);

  const modalElRef = useRef(null);       // ref do elemento
  const bsModalRef = useRef(null);       // ref da instância Bootstrap
  const openTimeoutRef = useRef(null);   // timer para abertura com delay
  const closeTimeoutRef = useRef(null);  // timer para fechamento automático
  const modalDataRef = useRef(null);     // dados atuais, lidos pelos listeners do Bootstrap
  modalDataRef.current = modalData;
  const isAuthRef = useRef(isAuthenticated);
  isAuthRef.current = isAuthenticated;
  const isModalLockedRef = useRef(isModalLocked);
  isModalLockedRef.current = isModalLocked;

  // Inicializa 1x a instância do Bootstrap modal e liga os eventos
  useEffect(() => {
    const el = modalElRef.current;
    if (!el) return;

    // Cria instância uma única vez
    bsModalRef.current = BootstrapModal.getOrCreateInstance(el, {
      backdrop: true,     // permite fechar clicando fora
      keyboard: true,     // ESC fecha
      focus: true,
    });

    // Quando o Bootstrap TERMINA de fechar, sincroniza React state
    const onHidden = () => {
      // Cancela timers quando o modal fecha
      if (openTimeoutRef.current) {
        clearTimeout(openTimeoutRef.current);
        openTimeoutRef.current = null;
      }
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
        closeTimeoutRef.current = null;
      }
      const onCloseCb = modalDataRef.current?.onClose;
      // Garante que o contexto “saiba” que está fechado
      closeModal();
      // Só executa o onClose (ex: redirecionar para home) se não autenticou
      if (typeof onCloseCb === "function" && !isAuthRef.current) {
        onCloseCb();
      }
    };

    // Modal obrigatório ou travado durante processamento de pagamento:
    // X, ESC e clique fora não fecham. Só o botão do conteúdo,
    // que limpa modalData (closeModal) antes de chamar hide().
    const onHide = (e) => {
      if (isModalLockedRef.current) {
        e.preventDefault();
        return;
      }
      if (modalDataRef.current?.fromPrivateRoute) {
        // Rota protegida: fechar é permitido e aciona onClose enviando para home
        return;
      }
      if (modalDataRef.current?.required) e.preventDefault();
    };

    el.addEventListener('hidden.bs.modal', onHidden);
    el.addEventListener('hide.bs.modal', onHide);

    return () => {
      el.removeEventListener('hidden.bs.modal', onHidden);
      el.removeEventListener('hide.bs.modal', onHide);
      // Dispose na desmontagem
      bsModalRef.current?.dispose();
      bsModalRef.current = null;
    };
  }, [closeModal]);

  // Reage às mudanças de isModalOpen, com delay opcional e autoclose
  useEffect(() => {
    const instance = bsModalRef.current;
    if (!instance) return;

    // Limpa timers prévios
    if (openTimeoutRef.current) {
      clearTimeout(openTimeoutRef.current);
      openTimeoutRef.current = null;
    }
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }

    if (isModalOpen) {
      const delayMs = typeof modalData?.delayMs === 'number' ? modalData.delayMs : 0;
      const autoCloseMs = typeof modalData?.autoCloseMs === 'number' ? modalData.autoCloseMs : null;

      openTimeoutRef.current = setTimeout(() => {
        instance.show();
        if (autoCloseMs && autoCloseMs > 0) {
          closeTimeoutRef.current = setTimeout(() => {
            instance.hide();
          }, autoCloseMs);
        }
      }, Math.max(0, delayMs));
    } else {
      instance.hide();
    }
  }, [isModalOpen, modalData]);

  // useEffect(() => {
  //   const modalElement = document.getElementById('bootstrapModal');
  //   if (modalElement) {
  //     if (isModalOpen) {
  //       const modal = new BootstrapModal(modalElement);
  //       modal.show();
  //     } else {
  //       const modalInstance = BootstrapModal.getInstance(modalElement);
  //       if (modalInstance) {
  //         modalInstance.hide();
  //       }
  //     }
  //   }
  // }, [isModalOpen]);

  let content;
  let model;

  if (modalType === "chat") {
    model = "";
    content = <Chat />;
  } else if (modalType === "who") {
    model = "modal-lg";
    content = <ModalSlider />;
  } else if (modalType === "excellence") {
    model = "modal-lg";
    const image = "excelencia.jpg";
    const title = "Puríssima:<br>Amor pela excelência";
    const subtitle = '<em>"Nós somos o que fazemos repetidamente. A excelência, portanto, não é um ato, mas um hábito."</em> - Aristóteles';
    const description = "<p>Criamos a Puríssima para ser tudo o que apreciamos: um serviço de qualidade máxima, com atendimento elegante e eficiente, com preços acessíveis e inclusivos, que traga resultados notáveis através da excelência de sua entrega.</p><p>Apreciamos aquilo que é minuciosamente bem feito, e criamos a Puríssima para nós, nossas famílias e amigos.</p><p>Saúde é algo sagrado. Levamos a sério nosso compromisso em te oferecer soluções de saúde que realmente entregam resultados.</p><p>Apenas trabalhamos com nutrientes e compostos na qualidade e dosagem que de fato demonstram efetividade em criteriosos estudos científicos.</p><p>Nossas fórmulas - personalizadas sob medida - são feitas com ingredientes de nova geração, digestibilidade e assimilação otimizados, e sempre puríssimos - livres de contaminantes de qualquer tipo.</p><p>Nosso conceito de sucesso não é o resultado financeiro, mas a certeza de estarmos de fato auxiliando na evolução e transformação positiva de cada cliente.</p>";
    content = <ModalCard image={image} title={title} subtitle={subtitle} description={description} />;
  } else if (modalType === "values") {
    model = "modal-lg";
    const image = "valores-proposito.jpg";
    const title = "Valores e Propósito";
    const subtitle = "Aquilo que nos motiva e inspira.";
    const description = "<ul><li><h4>QUALIDADE ABSOLUTA</h4><p>Do ingrediente à embalagem, cada detalhe é criado para ser <strong>o melhor</strong> possível. Afinal, criamos a Puríssima para atender à nossa família e amigos.</p></li><li><h4>INTEGRIDADE</h4><p>A certeza de obter, em cada cápsula ou embalagem, exatamente o que está listado no rótulo. Nem mais, nem menos, em um sistema de <strong>controle de segurança</strong> com dez etapas.</p></li><li><h4>EFETIVIDADE</h4><p>A base da saúde é a nutrição, e a Puríssima endereça isto em primeiro lugar. Os melhores compostos nutritivos que a ciência já identificou, associados aos melhores extratos saudáveis e medicinais.</p></li><li><h4>INDIVIDUALIDADE</h4><p>Sua fórmula de saúde personalizada, com as dosagens exatasde cada ingrediente que sua saúde precisa.</p></li><li><h4>SIMPLICIDADE</h4><p>Basta passar pela consulta digital Puríssima e receber em casa os nutrientes e remédios naturais sob medida para você. Uma fórmula de manhã, outra de noite. Tudo que você precisa.</p></li><li><h4>ACESSIBILIDADE</h4><p>Saúde é sagrada por isso criamos a Puríssima para ser acessível: nosso modelo de venda direta e negociação com fornecedores nos permite oferece a melhor qualidade pelo melhor preço. Compare e perceba.</p></li><li><h4>HUMANIDADE</h4><p>Atendimento personalizado online realizado pela equipede farmacêuticas da Puríssima,para máxima personalizaçãode suas soluções de saúde.</p></li></ul>";
    content = <ModalCard image={image} title={title} subtitle={subtitle} description={description} />;
  } else if (modalType === "kitComposition") {
    model = "modal";
    const kitComposition = [
      {
        formula: '',
        ingredients: [
          {
            ingredient: 'Magnésio',
            dosage: '200 mg'
          },
          {
            ingredient: 'Magnésio',
            dosage: '200 mg'
          },
          {
            ingredient: 'Magnésio',
            dosage: '200 mg'
          },
        ]
      }
    ];
    content = <ModalList content={kitComposition} />;
  } else if (modalType === "kitDetails") {
    model = "modal-kit-details";
    content = <ModalSliderKitDetails />;
  } else if (modalType === "kitFormula") {
    model = "modal-kit-details";
    content = <ModalSliderKitFormula plano={modalData} />;
  } else if (modalType === "customScience") {
    model = "modal-kit-details";
    content = <ModalSliderCustom />;
  } else if (modalType === "kitFormulaFarma") {
    model = "modal-kit-details";
    content = <ModalKitContentFarma plano={modalData} />;
  } else if (modalType === "modalPesquisa") {
    model = "modal-md";
    if (SALES_SUSPENDED) {
      content = <ModalSalesSuspended key={openCount} />;
    } else if (!isAuthenticated) {
      // Dispara evento de interesse em cadastro (apenas não logado)
      fireEvent('Interesse', { category: 'Cadastro', label: 'modalPesquisa' });
      // Fecha o modal atual e abre o de login, guardando o que retomar depois de logar
      const pendingData = modalData;
      setTimeout(() => {
        closeModal();
        openModal("modalLogin", { resumeType: "modalPesquisa", resumeData: pendingData });
      }, 100);
      content = null;
    } else {
      content = <ModalCardPesquisa key={openCount} />;
    }
  } else if (modalType === "confirmation") {
    model = "modal-sm";
    content = <ModalInfo data={modalData} />;
  } else if (modalType === "confirmation_dialog") {
    model = "modal-md";
    content = <ModalConfirmation data={modalData} />;
  } else if (modalType === "anamnesisRenew") {
    model = "modal-sm";
    content = <ModalAnamnesisRenew data={modalData} />;
  } else if (modalType === "anamneseUpgradeV2") {
    model = "modal-sm";
    content = <ModalAnamneseUpgradeV2 data={modalData} />;
  } else if (modalType === "video") {
    model = "modal-lg";
    content = <ModalVideo data={modalData} />;
  } else if (modalType === "image") {
    model = "modal-sm";
    content = <ModalImage data={modalData} />;
  } else if (modalType === "modalBase") {
    model = "modal-lg";
    content = <ModalCardBase data={modalData} />;
  } else if (modalType === "modalLogin") {
    model = "modal-sm";
    content = <ModalLogin key={openCount} />;
  } else if (modalType === "modalSalesSuspended") {
    model = "modal-sm";
    content = <ModalSalesSuspended key={openCount} />;
  } else if (modalType === "modalFamilyProfile") {
    model = "modal-sm";
    content = <ModalFamilyProfile />;
  } else if (modalType === "modalModalidades") {
    model = "modal-sm";
    content = <ModalModalidades data={modalData} />;
  } else if (modalType === "terms") {
    model = "modal-lg";
    content = <ModalTerms data={modalData} />;
  } else if (modalType === "iframe") {
    model = "modal-xl";
    content = <ModalIframe data={modalData} />;
  } else if (modalType === "modalRetiradaLoja") {
    model = "modal-sm";
    content = <ModalRetiradaLoja />;
  } else if (modalType === "tracking") {
    model = "modal-md";
    content = <ModalTracking data={modalData} />;
  } else if (modalType === "modalPendingPayment") {
    model = "modal-md";
    content = <ModalPendingPayment key={openCount} data={modalData} />;
  } else if (modalType === "formLead") {
    model = "modal-form-lead";
    content = (
      <FormLead
        title={modalData?.title || "Quero reservar minha vaga"}
        acList={modalData?.acList}
        acTag={modalData?.acTag}
        acTags={modalData?.acTags}
        acMeta={modalData?.acMeta}
        successMessage={modalData?.successMessage}
        whatsappNumber={modalData?.whatsappNumber}
        whatsappMessage={modalData?.whatsappMessage}
        onSuccess={modalData?.onSuccess}
      />
    );
  } else {
    content = <p>Card sem conteúdo definido.</p>;
  }

  // return (

  //   <div className="modal fade" id="bootstrapModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="modalLabel" aria-hidden="true">
  //     <div className={`modal-dialog modal-dialog-centered ${model}`}>
  //       <div className="modal-content">
  //         <div className="modal-header">
  //           <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
  //         </div>
  //         <div className="modal-body">
  //           {content}
  //         </div>
  //       </div>
  //     </div>
  //   </div>

  // );

  return (
    <div
      className="modal fade"
      id="bootstrapModal"
      tabIndex="-1"
      aria-labelledby="modalLabel"
      aria-hidden="true"
      ref={modalElRef}
    >
      <div className={`modal-dialog modal-dialog-centered ${model}`}>
        <div className={`modal-content ${['image', 'tracking', 'modalPesquisa', 'modalPendingPayment', 'confirmation_dialog'].includes(modalType) ? 'border-0 overflow-hidden' : ''} ${['image', 'modalPendingPayment', 'confirmation_dialog'].includes(modalType) ? 'bg-transparent shadow-none' : ''}`}>
          {modalType !== 'image' && modalType !== 'confirmation' && modalType !== 'confirmation_dialog' && modalType !== 'tracking' && modalType !== 'modalPesquisa' && modalType !== 'modalPendingPayment' && (!modalData?.required || modalData?.fromPrivateRoute) && (
            <div className="modal-header">
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
          )}
          {(modalType === 'image' || modalType === 'tracking') && (
            <button type="button" className="btn-close position-absolute" style={{ top: 8, right: 8, zIndex: 2 }} data-bs-dismiss="modal" aria-label="Close"></button>
          )}
          <div className={`modal-body ${['image', 'confirmation', 'confirmation_dialog', 'tracking', 'modalPesquisa', 'modalPendingPayment'].includes(modalType) ? 'p-0' : ''}`}>{content}</div>
        </div>
      </div>
    </div>
  );

};

export default Modal;
